import {
  NetExposure,
  PnlData,
  SnapshotData,
} from '@/apis/statistics/statistics-api.def.ts'

export interface SummaryBuyingPowerData {
  buyingPower: number
  usedBuyingPower: number
}

export interface SummaryResolvedValues {
  usedBuyingPower: number
  totalBuyingPower: number
  netExposureOnGMV: number
  netCategory: string
  dailyPnl: number
  wtdPnl: number
  mtdPnl: number
  qtdPnl: number
  ytdPnl: number
  lmv: number
  smv: number
}

export interface ResolveSummaryValuesParams {
  isHistorical: boolean
  buyingPower?: SummaryBuyingPowerData
  netExposure?: NetExposure
  pnlData?: PnlData
  snapshotData?: SnapshotData
  userRegion: string
}

export function resolveSummaryValues(
  params: ResolveSummaryValuesParams
): SummaryResolvedValues {
  const {
    isHistorical,
    buyingPower,
    netExposure,
    pnlData,
    snapshotData,
    userRegion,
  } = params

  const first = <T>(
    historicalValue: T | undefined,
    liveValue: T | undefined
  ) =>
    isHistorical
      ? (historicalValue ?? liveValue ?? 0)
      : (liveValue ?? historicalValue ?? 0)

  return {
    usedBuyingPower: first(
      snapshotData?.usedBuyingPower,
      buyingPower?.usedBuyingPower
    ),
    totalBuyingPower: first(
      snapshotData?.buyingPower,
      buyingPower?.buyingPower
    ),
    netExposureOnGMV: first(
      snapshotData?.netExposureOnGMV,
      netExposure?.netExposureOnGMV
    ),
    netCategory: netExposure?.netCategory ?? userRegion,
    dailyPnl: first(snapshotData?.dailyPnl, pnlData?.dailyPnl),
    wtdPnl: first(snapshotData?.wtdPnl, pnlData?.wtdPnl),
    mtdPnl: first(snapshotData?.mtdPnl, pnlData?.mtdPnl),
    qtdPnl: first(snapshotData?.qtdPnl, pnlData?.qtdPnl),
    ytdPnl: first(snapshotData?.ytdPnl, pnlData?.ytdPnl),
    lmv: first(snapshotData?.lmv, netExposure?.lmv),
    smv: first(snapshotData?.smv, netExposure?.smv),
  }
}

export function normalizeSummaryNetCategory(category: string): string {
  if (category === 'Low Net') return 'Greater China - Low Net'
  if (category === 'Long Bias') return 'Greater China - Long Bias'
  return category
}
